import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "./css/less/moms.less?vue&type=style&index=0&lang=less&external"

const __exports__ = script;

export default __exports__